import { useAxios, useSubjectId } from '@healthblocks-io/core'
import useSWR from 'swr'

import type {
  PatientDocumentsFilterOption,
  PatientDocumentsGroupingOption,
  PatientDocumentsResponse,
  PatientViewDocument,
  PatientViewDocumentsByYear,
} from '../types/patient-documents.types'

export function usePatientDocuments(options?: {
  filter?: PatientDocumentsFilterOption
  groupBy?: PatientDocumentsGroupingOption
}) {
  const { filter = 'all', groupBy = 'none' } = options ?? {}

  const subjectId = useSubjectId()
  const hbAxios = useAxios()

  return useSWR(
    subjectId ? `/documents?subjectId=${subjectId}&filter=${filter}&groupBy=${groupBy}` : null,
    async () => {
      const response = await hbAxios.get<PatientDocumentsResponse>(`/views/patient/documents`, {
        params: {
          subjectId: subjectId?.toString() ?? '',
          filter,
          groupBy,
        },
      })

      const data =
        groupBy === 'year'
          ? ((response.data.data as PatientViewDocumentsByYear) ?? ({} as PatientViewDocumentsByYear))
          : ((response.data.data as PatientViewDocument[]) ?? ([] as PatientViewDocument[]))

      return {
        data,
        meta: response.data.meta,
      }
    },
  )
}
